import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MenuController, AlertController } from "@ionic/angular";
import { removeInitScreen } from "../../_helpers/appLoading";
import { CompanyService } from "src/app/app/company/company.service";
import { InvitationService } from "src/app/app/invitation/invitation.service";
import {
  Invitation,
  InvitationUrlActionDto,
} from "src/app/app/invitation/invitation.model";

@Component({
  selector: "app-invitation-accept",
  templateUrl: "./invitation-accept.page.html",
  styleUrls: [
    "./invitation-accept.page.scss",
    "./../../_styles/ion-grid-box.scss",
  ],
})
export class InvitationAcceptPage implements OnInit {
  constructor(
    private route: ActivatedRoute,
    public invtationServ: InvitationService,
    public menu: MenuController,
    public companyServ: CompanyService
  ) {}

  qrcodeKey: string;
  invitation: Invitation = new Invitation();
  isClosed: boolean = false;

  async ngOnInit() {
    await this.companyServ.loadCompaniesSync();

    let data = this.route.snapshot.data;
    this.invitation = data.data;
    this.isClosed = this.invitation.invitationGuests[0].acceptanceStatus === 3;

    this.route.paramMap.subscribe((paramMap) => {
      if (!paramMap.has("qrcode")) {
        return;
      }

      this.qrcodeKey = paramMap.get("qrcode");
    });

    this.menu.enable(false);
    removeInitScreen();
  }

  /**
   * Click accept invitation, accepts user, closing page at the end of operation.
   */
  async onAcceptClick() {
    const invtationUrlAction = new InvitationUrlActionDto();
    invtationUrlAction.key = this.qrcodeKey;
    invtationUrlAction.type = 1;

    this.invtationServ
      .confimInvitationPublic(invtationUrlAction)
      .subscribe(async (res) => {
        window.location.reload();
      });
  }
}
